import e from"react";const r=({breadcrumbs:r})=>e.createElement("div",{dangerouslySetInnerHTML:{__html:r}});export{r as Breadcrumb};
